import { render, staticRenderFns } from "./AsDetailAdditionalInformationContent.vue?vue&type=template&id=c1ca4024&scoped=true"
import script from "./AsDetailAdditionalInformationContent.vue?vue&type=script&lang=js"
export * from "./AsDetailAdditionalInformationContent.vue?vue&type=script&lang=js"
import style0 from "./AsDetailAdditionalInformationContent.vue?vue&type=style&index=0&id=c1ca4024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ca4024",
  null
  
)

export default component.exports